import { Fragment, useState, useRef, FC, useEffect } from "react"
import { Link, useHistory } from "react-router-dom"

import {
  login1,
  login2,
  loginReplace,
  loginUnlock,
  requestUserPermissions
} from "../../api/BackendCalls"

import { HandlingApp, PageId } from "../../common/pageId"
import { logonUser } from "../../containers/applicationSlice"

import useFormValidation from "../../hooks/useFormValidation"

import { ReactComponent as Logo } from "../../img/ocs-logo.svg"
import PPRLogo from "../../img/fraport-greece-logo.jpeg"
import Input from "../../components/generic/form/Input"
import Button from "../../components/generic/buttons/Button"
import { validateLogin } from "../../components/generic/form/validation/validateLogin"

import { LoginContent, PageContent } from "../../common/pageText"
import { CommonText } from "../../common/text"
import { integersOnlyRegex } from "../../common/regex"
import { CommonErrorText } from "../../common/errorText"
import PassPhraseForm from "./PassPhraseForm"
import LoginForm from "./LoginForm"
import { PageTemplate } from "../../components/pageTemplate/PageTemplate"
import AlertBox from "../../components/alertBox"
import { NotificationKind } from "../../containers/notificationSlice"
import { routeMap } from "../../components/generic/navbar/routeMap"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { LoadingPanel } from "../../components/generic"

interface Props {
  //menu: IMenuItem[]
}
const Module: FC<Props> = () => {
  const initialUserValue = {
    username: "",
    password: "",
    first: "",
    second: "",
    unlockCode: ""
  }

  const initialState = {
    insertPassPhrase: false,
    anotherUser: false,
    loginCodeSent: false
  }

  const { userInfo, menu, versionInfo } = useAppSelector(
    (state) => state["appReducer"]
  )
  const notifications = useAppSelector(
    (state) => state["notificationReducer"].notifications
  )
  const history = useHistory<{ from: any }>()

  const [state, setState] = useState(initialState)

  const { anotherUser, loginCodeSent, insertPassPhrase } = state

  const passPhraseInputRef = useRef<HTMLInputElement>(null)

  const {
    handleChange,
    values,
    errors,
    handleBlur,
    handleSubmit,
    handleLogoutUser,
    handleUnlockCode
  } = useFormValidation(
    initialUserValue,
    validateLogin,
    onCallback,
    passPhraseInputRef
  )

  const { username, password, unlockCode } = values
  const [alert, setAlert] = useState(null)
  const [contactText, setContactText] = useState("")
  const [challengeText, setChallengeText] = useState("")
  const [dangerText, setDangerText] = useState("")
  const [showInitForm, setShowInitForm] = useState(true)
  const [loading, setLoading] = useState(false)
  const pageId = PageId.DefaultPage

  useEffect(() => {
    if (userInfo.authenticated && menu.isAuth) {
      if (history.location.state) {
        history.push(history.location.state.from.pathname)
      } else {
        history.push("/")
      }
    }
    // eslint-disable-next-line
  }, [userInfo, menu])

  useEffect(() => {
    if (notifications.length > 0) {
      setAlert({
        kind: notifications[0].kind,
        title: "",
        message: notifications[0].message
      })
    }
  }, [notifications])

  const initialText = "Please try again later or contact us."
  // initial call with username + password (Next btn)
  const handleSteps = async (e) => {
    setAlert(null)
    const parameters = {
      username,
      password
    }

    e.preventDefault()

    const isValid = values.username !== "" && values.password !== ""

    if (isValid) {
      setLoading(true)
      const result = await login1(pageId, parameters)
      const hasResultMsg = result?.message !== ""

      if (result) {
        setLoading(false)
      }

      const status = result.authStatus
      const isLocked = status === "locked"

      if (hasResultMsg) {
        const contactMessage = result.message.includes("contact")

        if (contactMessage && status === null) {
          const oldMessage = result.message.replace("please contact us", "")

          setAlert({
            kind: NotificationKind.ERROR,
            title: "",
            message: oldMessage
          })
          setContactText("Please contact us.")
        } else {
          setContactText("")
          setAlert({
            kind: NotificationKind.ERROR,
            title: "",
            message: result.message
          })
        }
        if (contactMessage && isLocked) {
          const oldMessage = result.message.replace(initialText, "")

          setAlert({
            kind: NotificationKind.ERROR,
            title: "",
            message: oldMessage
          })
          setContactText(initialText)
        }
      }

      const success = status === "preauthenticated"
    if (success) {
      requestUserPermissions(pageId)
    }	  
	  
      if (result.challengeText !== "") {
        setChallengeText(result.challengeText)
      }

      const anotherUser = status === "next_user"

      if (anotherUser) {
        setShowInitForm(false)
      }

      setState({
        ...state,
        insertPassPhrase: success,
        anotherUser: anotherUser,
        loginCodeSent: isLocked
      })
    }
  }

  // call with two chars (Login btn)
  const tryLogin2 = async () => {
    const firstLetter = values.first
    const secondLetter = values.second

    const parameters = {
      char12: firstLetter + secondLetter
    }
    setLoading(true)
    const result = await login2(PageId.DefaultPage, parameters)
    const status = result && result.authStatus
    if (result) {
      setLoading(false)
    }
    const contactMessage = result?.message?.includes("contact")
    const isLocked = status === "locked"
    if (isLocked) {
      setState({
        ...state,
        insertPassPhrase: false
      })
    }
    if (contactMessage && isLocked) {
      const oldMessage = result.message.replace(initialText, "")

      setAlert({
        kind: NotificationKind.ERROR,
        title: "",
        message: oldMessage
      })
      setContactText(initialText)
    }
    return result
  }

  // on submit after validation (login2)
  async function onCallback() {
    const isValid = values.first !== "" && values.second !== ""

    if (isValid) {
      const result = await tryLogin2()

      const status = result && result.authStatus
      if (status === "authenticated") {
        dispatch(logonUser({ loginName: username, authenticated: true }))
      }

      const isLocked = status === "locked"
      if (!isLocked) {
        setAlert(
          result &&
            result.message !== "" && {
              kind: NotificationKind.ERROR,
              title: "",
              message: result.message
            }
        )
      }
      const anotherUser = status === "next_user"
      setState({
        ...state,
        loginCodeSent: isLocked,
        anotherUser: anotherUser
      })
    }
  }
  //Enter unlock code
  const handleUnlock = async (e) => {
    e.preventDefault()
    const parameters = {
      unlockCode: Number(unlockCode)
    }
    setContactText("")
    handleUnlockCode()
    const validUnlockCode = integersOnlyRegex.test(unlockCode)
    if (validUnlockCode) {
      const result = await loginUnlock(PageId.DefaultPage, parameters)
      const hasResultMsg = result && result.message !== ""
      const isLocked = result && result.authStatus === "locked"
      if (!isLocked) {
        setAlert(
          hasResultMsg && {
            kind: NotificationKind.SUCCESS,
            title: "",
            message: result.message
          }
        )

        setShowInitForm(true)
        setState({
          ...state,
          loginCodeSent: false,
          insertPassPhrase: false
        })
      } else {
        setAlert(
          hasResultMsg && {
            kind: NotificationKind.ERROR,
            title: "",
            message: result.message
          }
        )
      }

      return result
    } else {
      setDangerText(CommonErrorText.invalid)
    }
    if (unlockCode === "") {
      setDangerText(CommonErrorText.noEmptyValue)
    }
  }

  //Logout current user
  const handleLoginReplace = async (e) => {
    const parameters = {}
    e.preventDefault()
    handleLogoutUser()
    setLoading(true)
    const result = await loginReplace(PageId.DefaultPage, parameters)
    if (result) {
      setLoading(false)
    }
    const isPreAuth = result && result.authStatus === "preauthenticated"
    //history.goBack()
    // setCurrentStep(1)
    if (isPreAuth) {
      setShowInitForm(true)
      setAlert({
        kind: NotificationKind.SUCCESS,
        title: "",
        message: "Other session succesfully closed"
      })
    }
    // setState({
    //   ...state,
    //   loginCodeSent: true
    // })
    return result
  }

  //Cancel
  const handleCancel = () => {
    if (history.location.state) {
      history.goBack()
    } else {
      history.push("/")
    }
  }
  const dispatch = useAppDispatch()

  return (
    <PageTemplate
      pageTitle="Login"
      pageContentClassName="bg-none"
      pageClassName="ocs-login-bg"
    >
      <section className=" main-page-container sm ocs-login">
        {loading && (
          <LoadingPanel visible={true} loadingTxt="Loading Response..." />
        )}
        <div className="ocs-login-container">
          <header className="ocs-login-header">
            <div className="logo d-flex justify-content-center">
              {versionInfo.handlingApplication === HandlingApp.FRAPORTGR ? (
                <img src={PPRLogo} alt="logo" />
              ) : (
                <Logo />
              )}
            </div>
          </header>
          <div className="login-alert-container d-flex align-items-center">
            {alert && (
              <AlertBox
                type={alert.kind}
                message={
                  contactText === "" ? (
                    alert.message
                  ) : (
                    <span>
                      {alert.message} <Link to="/contactUs">{contactText}</Link>
                    </span>
                  )
                }
                className="login-alert"
              />
            )}
          </div>
          <article className="d-flex flex-column align-items-center">
            <form className="ocs-form" autoComplete="off">
              {insertPassPhrase && !loginCodeSent && (
                <div className="ocs-login-text">
                  <p>
                    Please type the{" "}
                    <span className="text-bold">{challengeText}</span> character
                    in your pass phrase
                  </p>
                </div>
              )}
              {showInitForm && !loginCodeSent ? (
                <Fragment>
                  <fieldset
                    className={
                      !insertPassPhrase ? "" : "d-flex ocs-login-pass-phrase"
                    }
                  >
                    {!insertPassPhrase ? (
                      <LoginForm
                        value={values}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errors={errors}
                      />
                    ) : (
                      <PassPhraseForm
                        value={values}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        inputRef={passPhraseInputRef}
                      />
                    )}
                  </fieldset>
                  {insertPassPhrase && (
                    <p className="text-danger">
                      {errors.first || errors.second}
                    </p>
                  )}

                  <div className="ocs-btn-group d-flex">
                    <Button
                      type="button"
                      onClick={handleCancel}
                      className="btn-margin mq-btn-height"
                    >
                      {CommonText.cancel}
                    </Button>
                    {!insertPassPhrase && (
                      <Button
                        type="submit"
                        onClick={handleSteps}
                        variant="primary"
                        className="mq-btn-height"
                      >
                        {CommonText.next}
                      </Button>
                    )}

                    {insertPassPhrase && (
                      <Button
                        type="submit"
                        onClick={handleSubmit}
                        variant="primary"
                        className="mq-btn-height"
                      >
                        {CommonText.login}
                      </Button>
                    )}
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  {loginCodeSent && (
                    <div>
                      <Input
                        value={unlockCode}
                        name="unlockCode"
                        onChange={handleChange}
                        inputIdentifier="unlockCode"
                        maxLength={100}
                        label="Unlock Code"
                        autoFocus
                      />

                      <p className="text-danger">{dangerText}</p>
                    </div>
                  )}
                  <div
                    className={
                      "ocs-btn-group d-flex " +
                      (loginCodeSent ? "unlock-code-sent" : "")
                    }
                  >
                    <Button
                      type="button"
                      onClick={handleCancel}
                      className="btn-margin"
                    >
                      {CommonText.cancel}
                    </Button>
                    {anotherUser && (
                      <Button
                        type="submit"
                        onClick={handleLoginReplace}
                        variant="primary"
                        className="mq-btn-height"
                      >
                        {LoginContent.logUserOutBtn}
                      </Button>
                    )}
                    {loginCodeSent && (
                      <Button
                        type="submit"
                        onClick={handleUnlock}
                        variant="primary"
                        className="mq-btn-height"
                      >
                        {LoginContent.unlockBtn}
                      </Button>
                    )}
                  </div>
                </Fragment>
              )}
            </form>
          </article>
        </div>
        <footer className="login-footer">
          {LoginContent.disclaimerText}
          <br />
          <Link to={routeMap[PageId.Disclaimer]}>{PageContent.disclaimer}</Link>
          {" and "}
          <Link to={routeMap[PageId.Cookies]}>{PageContent.cookies}</Link>
        </footer>
      </section>
    </PageTemplate>
  )
}

export default Module
